export default __webpack_public_path__ + "static/media/apricityCareLogo.6f84bf2b.png";